const switchSizeOptions = {
  SMALL: 'small',
  LARGE: 'large'
}

const switchStyleOptions = {
  [switchSizeOptions.LARGE]: {
    width: '56px',
    height: '32px',
    thumb: {
      width: '26px',
      height: '26px'
    }
  },
  [switchSizeOptions.SMALL]: {
    width: '42px',
    height: '24px',
    thumb: {
      width: '18px',
      height: '18px'
    }
  }
}

export { switchSizeOptions, switchStyleOptions }
